import { useCallback, useEffect } from 'react';
import { useAuctionStore } from '../stores/auctionStore';
import { auctionService } from '../services/auctionService';
export const useAuctionList = () => {
    const { auctions, pagination, filters, isLoading, error, setAuctions, setFilters, setLoading, setError, } = useAuctionStore();
    const fetchAuctions = useCallback(async (page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const result = await auctionService.listAuctions({
                status: filters.status === 'all' ? undefined : filters.status,
                type: filters.type === 'all' ? undefined : filters.type,
                page,
                pageSize: pagination.pageSize,
            });
            if (result.success) {
                setAuctions(result.data.auctions, result.data.pagination);
            }
            else {
                setError('Failed to load auctions');
            }
        }
        catch (err) {
            setError(err.message || 'Failed to load auctions');
        }
        finally {
            setLoading(false);
        }
    }, [filters, pagination.pageSize, setAuctions, setFilters, setLoading, setError]);
    const changeFilters = useCallback((newFilters) => {
        setFilters(newFilters);
    }, [setFilters]);
    const changePage = useCallback((page) => {
        fetchAuctions(page);
    }, [fetchAuctions]);
    const refresh = useCallback(() => {
        fetchAuctions(pagination.page);
    }, [fetchAuctions, pagination.page]);
    useEffect(() => {
        fetchAuctions(1);
    }, [filters.status, filters.type]);
    return {
        auctions,
        pagination,
        filters,
        isLoading,
        error,
        changeFilters,
        changePage,
        refresh,
    };
};
